
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#1BA6DF"}},[_c('path',{attrs:{"d":"M31.122 30.67a1.166 1.166 0 00-.443-1.14A21.205 21.205 0 0122.4 16.409a1.166 1.166 0 00-1.32-.964 8.98 8.98 0 00-4.57 2.1 1.167 1.167 0 01-1.525 0 9.014 9.014 0 00-5.922-2.202C3.983 15.328 0 20.137 0 26.273a18.2 18.2 0 003.696 11.868 1.167 1.167 0 01.2 1.127 26.917 26.917 0 00-1.467 8.88c-.002 1.899.19 3.792.572 5.652A2.77 2.77 0 005.703 56a2.826 2.826 0 002.814-2.522c.6-5.49 3.708-9.63 7.233-9.63 3.526 0 6.634 4.14 7.233 9.632A2.826 2.826 0 0025.797 56a2.77 2.77 0 002.703-2.2c.382-1.86.573-3.753.571-5.652a26.904 26.904 0 00-1.468-8.878 1.18 1.18 0 01.199-1.13 16.17 16.17 0 003.32-7.47zM53.834 2.427A38.309 38.309 0 0040.784 0a37.378 37.378 0 00-12.952 2.427 3.605 3.605 0 00-2.166 3.304v7.917a18.002 18.002 0 0012.11 15.866c.934.482 1.958.76 3.006.82a7.574 7.574 0 003.008-.81C50.977 26.784 56 20.258 56 13.648V5.73a3.605 3.605 0 00-2.166-3.304zm-6 12.74h-3.5a1.167 1.167 0 00-1.168 1.166v3.5a2.333 2.333 0 11-4.666 0v-3.5a1.167 1.167 0 00-1.167-1.166h-3.5a2.333 2.333 0 110-4.667h3.5A1.167 1.167 0 0038.5 9.333v-3.5a2.333 2.333 0 014.666 0v3.5a1.167 1.167 0 001.167 1.167h3.5a2.333 2.333 0 110 4.667z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h56v56H0z"}})])])])
          )
        }
      }
    